/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authManageNotifications.defs.js'
export * as $defs from './authManageNotifications.defs.js'
